export const csvDownloadConstants = {

    // REQUEST_CSV_DOWNLOAD
    REQUEST_CSV_DOWNLOAD: 'REQUEST_CSV_DOWNLOAD',
    RECIEVE_CSV_DOWNLOAD: 'RECIEVE_CSV_DOWNLOAD',
    ERROR_CSV_DOWNLOAD: 'ERROR_CSV_DOWNLOAD',

};



// WEBPACK FOOTER //
// ./src/_constants/csvDownload.constants.js